function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { stringify, parse } from "query-string"; // API query string management

function buildQueryString(params) {
  var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var p;

  if (typeof params === "string") {
    p = params;
  } else {
    p = stringify(params, _objectSpread({
      arrayFormat: "comma"
    }, opts));
  }

  return p;
}

function buildQueryURL(route) {
  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var opts = arguments.length > 2 ? arguments[2] : undefined;
  var queryStr = buildQueryString(params, opts);

  if (queryStr == "") {
    return route;
  } else {
    return route + "?" + queryStr;
  }
} // Base query string management


function parseParams(paramString, opts) {
  var params = parse(paramString, _objectSpread({
    parseBooleans: true,
    parseNumbers: true,
    arrayFormat: "comma"
  }, opts)); // Return null unless we have params defined

  return Object.keys(params).length > 0 ? params : null;
}

function updateURL(joinWith, args, opts) {
  var params = buildQueryString(args, opts);
  var pathname = document.location.pathname;

  if (params != "") {
    pathname += joinWith + params;
  }

  window.history.replaceState({}, "", pathname);
}

var getHashString = function getHashString(hashString) {
  return parseParams(hashString !== null && hashString !== void 0 ? hashString : document.location.hash);
};

var setHashString = function setHashString(args, opts) {
  return updateURL("#", args, opts);
};

var getQueryString = function getQueryString(queryString) {
  return parseParams(queryString !== null && queryString !== void 0 ? queryString : document.location.search);
};

var setQueryString = function setQueryString(args, opts) {
  return updateURL("?", args, opts);
};

export { buildQueryString, buildQueryURL, getQueryString, setQueryString, getHashString, setHashString };